module.exports = __webpack_public_path__ + "img/sdk-0-3.ef3038f.svg";